<div
  class="select-container"
  [style.width]="width"
>
  <div class="header">
    @if (label) {
      <div class="label">{{ label }}</div>
    }

    @if (link && text) {
      <div>
        <app-link [link]="link" [text]="text"/>
      </div>
    }
  </div>

  @if (isDisabled) {
    <div class="dropdown">
      <button
        type="button"
        class="input-wrapper input"
        [class]="{'opened': dropdownOpen}"
        [disabled]="isDisabled"
      >
        @if (value !== null && value !== undefined) {
          <ng-container
            [ngTemplateOutlet]="shareholderCard"
            [ngTemplateOutletContext]="{ securityRegistryRecord: value[0] }"
          />
        } @else {
          <div class="select-placeholder">{{ placeholder }}</div>
        }
        <span class="icon ic-select-20"></span>
      </button>
    </div>
  } @else {
    <div ngbDropdown class="dropdown" (openChange)="getDropdownState($event)">
      <button
        type="button"
        class="input-wrapper input"
        [class]="{'opened': dropdownOpen}"
        [disabled]="isDisabled"
        ngbDropdownToggle
      >
        @if (value !== null && value !== undefined) {
          <ng-container
            [ngTemplateOutlet]="shareholderCard"
            [ngTemplateOutletContext]="{securityRegistryRecord: value[0]}"
          />
        } @else {
          <div class="select-placeholder">{{ placeholder }}</div>
        }
        <span class="icon ic-select-20"></span>
      </button>
      <div ngbDropdownMenu class="dropdown-menu">
        @if (groupedSecurityRegistryRecords.length) {
          @for (securityRegistryRecordGroup of groupedSecurityRegistryRecords; track trackGroupedSecurityRegistryRecordsFn($index, securityRegistryRecordGroup)) {
            <button
              ngbDropdownItem
              type="button"
              class="dropdown-item"
              [class.selected]="value === securityRegistryRecordGroup"
              [disabled]="isDisabled"
              (click)="selectOption(securityRegistryRecordGroup)"
            >
              <div class="dropdown-button">
                <ng-container
                  [ngTemplateOutlet]="shareholderCard"
                  [ngTemplateOutletContext]="{ securityRegistryRecord:  securityRegistryRecordGroup[0] }"
                />
                <span class="icon ic-checkmark-circle-16"></span>
              </div>
            </button>
          }
        } @else {
          <div class="no-options">{{ noOptionsText }}</div>
        }
      </div>
    </div>
  }

  @if (helperText) {
    <div class="helper">{{ helperText }}</div>
  }

  @if (displayValidationError) {
    <app-validation-error [customErrors]="customSignErrors"/>
  }
</div>

<ng-template #shareholderCard let-securityRegistryRecord="securityRegistryRecord">
  <div class="shareholder-card">
    @for (holder of securityRegistryRecord?.holders; track holder.relationshipId) {
      <app-security-holder-icon-label [holder]="holder"/>
    }

    @if (!securityRegistryRecord.isBeneficialOwner) {
      <span>as Trustee for {{ securityRegistryRecord.beneficialOwner }}</span>
    }
  </div>
</ng-template>
